export interface TutorialStep {
  symbol: string;
  title: string;
  detail: string;
  points?: readonly string[];
  example?: { label: string; text: string };
}

export const tutorialSteps: readonly TutorialStep[] = [
  {
    symbol: "⚖",
    title: "两个阵营，一项使命",
    detail: "善良人数更多，但不知道谁可信；邪恶人数更少，却知道如何制造混乱。",
    points: ["善良：找出并处决恶魔。", "邪恶：保护恶魔，直到只剩两名存活玩家。"],
    example: { label: "先记住", text: "角色是秘密，阵营也是秘密。发言可以真实、保留，甚至故意伪装。" },
  },
  {
    symbol: "♟",
    title: "系统就是隐形说书人",
    detail: "系统负责分发身份、保守秘密、按夜序收集行动、发送线索，并自动结算死亡与胜负。",
    points: ["只相信自己手机上显示的私密信息。", "手机与可选大屏都会展示昼夜、提名、票数、死亡等公开事件。"],
    example: { label: "你要做的", text: "手机提示选择目标时完成操作；显示等待时放下手机，不需要额外主持人。" },
  },
  {
    symbol: "♜",
    title: "四类角色，各有职责",
    detail: "镇民和外来者属于善良；爪牙和恶魔属于邪恶。每个角色的能力、风险和发言方式不同。",
    points: ["镇民用信息或保护能力推进判断。", "外来者属于善良，但能力可能带来限制或危险。", "爪牙制造假信息并保护恶魔；恶魔每夜杀人。"],
    example: { label: "例子", text: "调查员会得到爪牙线索；隐士虽是好人，却可能被调查员登记成爪牙。" },
  },
  {
    symbol: "☾",
    title: "夜晚看手机，白天看彼此",
    detail: "夜晚闭眼并只看自己的手机；白天放下手机，面对面讨论、提名与投票。",
    points: ["夜间目标和私密线索不要让邻座看到。", "白天可公开线索，也可暂时隐瞒来观察其他人。"],
    example: { label: "一轮流程", text: "夜晚行动完成 → 黎明公布死亡 → 自由讨论 → 提名投票 → 日落处决 → 再次入夜。" },
  },
  {
    symbol: "?",
    title: "信息可能并不可靠",
    detail: "中毒者与酒鬼的能力失效，系统仍会给出看似正常、但可能错误的信息；玩家不会收到“你中毒了”的提醒。",
    points: ["酒鬼看到并相信自己是某个镇民，整局不知道真相。", "隐士可能被信息能力登记成邪恶、爪牙或恶魔。"],
    example: { label: "本局常见情况", text: "酒鬼以为自己是调查员，可能拿到错误线索；他实际是外来者，所以提名处女不会触发处女处决。" },
  },
  {
    symbol: "◈",
    title: "好人也不必立刻说出身份",
    detail: "公开全部身份会帮助恶魔选择夜间目标。可以先分享部分信息、换一种角色说法，或等关键时机再揭晓。",
    points: ["强信息角色可先只说结论，不说精确目标。", "守鸦人可冒充更危险的角色，尝试吸引恶魔夜袭。"],
    example: { label: "发言示例", text: "“我有理由怀疑三号，但暂时不公开我的角色；如果我明天还活着会补充。”" },
  },
  {
    symbol: "♞",
    title: "邪恶如何冒充镇民",
    detail: "邪恶玩家要选择一个可信的善良身份，并让每天的发言与这个身份能力一致。不要只说“我是好人”。",
    points: ["小恶魔可冒充士兵：解释自己为何可能夜里不死，但仍会被处决。", "男爵可冒充调查员：编造“两人中有一位爪牙”的线索，推动好人互相怀疑。"],
    example: { label: "伪装示例", text: "男爵声称：“二号和五号中有一位是投毒者。”随后观察两人的角色声明，再逐步调整说法。" },
  },
  {
    symbol: "✦",
    title: "提名、投票与处决",
    detail: "存活玩家每天最多提名一次；每名玩家每天最多被提名一次，自己和死者也可成为目标。在手机上投票，日落时结算最高有效票。",
    points: ["票数需达到存活人数的一半（向上取整）。", "最高票平局则无人被处决。", "处女首次被镇民提名时，提名者立即被处决并结束白天。"],
    example: { label: "六人局", text: "六人都存活时门槛是 3 票；两位候选人同为 3 票，日落时无人被处决。" },
  },
  {
    symbol: "†",
    title: "死亡不是离场",
    detail: "死亡后仍能发言和参与推理，但不能再提名，并且整局只剩一张幽灵票。",
    points: ["幽灵票用掉后无需投票；死亡玩家不回应也不会卡住结算。", "把幽灵票留给最可能处决恶魔的关键轮次。"],
    example: { label: "注意", text: "士兵只免疫恶魔造成的死亡；处决、处女能力等其他死亡来源仍然有效。" },
  },
  {
    symbol: "Ⅵ",
    title: "五至六人局的重要特例",
    detail: "五至六人属于小型局：恶魔和爪牙在开局时不会得知彼此是谁，小恶魔也不会获得三个系统提供的安全伪装。",
    points: ["邪恶玩家需要从发言中寻找可能的队友。", "身份声明撞车不一定立刻暴露邪恶，因为没有预先分配的安全伪装。"],
    example: { label: "实战建议", text: "先用温和、可修正的线索试探；不要第一天就用只有队友才懂的强暗号。" },
  },
  {
    symbol: "◎",
    title: "始终看“当前任务”",
    detail: "系统会明确显示现在需要行动、选择谁、是否举手，或只需等待。大屏同步显示村庄公开信息与昼夜阶段。",
    points: ["断线重连后会恢复你的座位、身份和当前步骤。", "教程、你的角色和完整角色表在游戏中可随时打开。"],
    example: { label: "准备好了", text: "不确定规则时先打开“我的角色”；涉及公开进程时看大屏的“村庄公开信息”。" },
  },
] as const;

export const roleTypeNames = {
  TOWNSFOLK: "镇民",
  OUTSIDER: "外来者",
  MINION: "爪牙",
  DEMON: "恶魔",
} as const;

export const roleTypeGuidance = {
  TOWNSFOLK: "善良阵营。利用能力和讨论找出恶魔。",
  OUTSIDER: "善良阵营，但能力常带来限制或危险。",
  MINION: "邪恶阵营。制造假信息并保护恶魔。",
  DEMON: "邪恶核心。夜间杀人，并避免白天被处决。",
} as const;

export interface RolePlayGuide {
  mechanics: string;
  play: string;
  example: string;
  bluff: string;
}

export const rolePlayGuides: Record<string, RolePlayGuide> = {
  washerwoman: {
    mechanics: "首夜会看到一个镇民角色名和两名玩家，其中恰有一人被系统登记为该角色。醉酒或中毒时，这组信息可能错误。",
    play: "先听两人的身份与信息，再决定公开角色名还是只公布座位；过早报全信息会给邪恶提供伪装。",
    example: "你得知二号与五号中有一位是厨师。可以先问两人的首夜信息，等说法稳定后再公开完整线索。",
    bluff: "邪恶冒充洗衣妇时必须同时编出一个镇民角色和两名候选人；追问其公开线索的时机与变化，容易发现临时改口。",
  },
  librarian: {
    mechanics: "首夜得知两名玩家中有一位是某个外来者；若本局没有外来者，系统会明确告诉你。登记异常可能影响结果。",
    play: "外来者属于善良，不要把线索直接当作处决名单；重点核对外来者人数是否与角色声明吻合。",
    example: "你得知一号与四号中有一位是圣徒。公开前要考虑邪恶是否正等着冒充圣徒来阻止处决。",
    bluff: "这是邪恶容易编造的首夜身份。可追问具体外来者、两名候选人，以及为何选择现在公开。",
  },
  investigator: {
    mechanics: "首夜得知两名玩家中有一位被登记为某个爪牙。隐士可能被登记成爪牙，醉酒或中毒也可能使信息错误。",
    play: "这是强线索而非绝对判决；让两名候选人都完整发言，再结合票型和其他信息缩小范围。",
    example: "你得知三号与六号中有一位是男爵。若三号自称隐士，信息仍可能完全符合规则。",
    bluff: "男爵或投毒者很适合冒充调查员并制造二选一。观察其线索是否只攻击好人、是否随局势不断换目标。",
  },
  chef: {
    mechanics: "首夜得到邪恶玩家相邻成对的数量，首尾座位也相邻。计算依据原始座次，死亡不会改变邻接关系。",
    play: "把数字与邪恶人数、座位排列结合使用；数字为零时可减少相邻两人同时为邪恶的可能。",
    example: "六人局得到 1，说明至少存在一对相邻、被登记为邪恶的玩家，但不能仅凭这一点确定是哪一对。",
    bluff: "厨师数字简短，常被邪恶冒充。要求其解释数字如何限制座位组合，比只听一个数字更有效。",
  },
  empath: {
    mechanics: "每夜得到左右两侧最近存活邻居中，被登记为邪恶的数量；邻座死亡后会继续向外寻找。",
    play: "连续几夜的变化比单夜数字更有价值。记录每次死亡前后的邻居与读数。",
    example: "昨夜读数为 1；左邻死亡后今夜变成 0，新的邻接关系可帮助判断原左邻或另一侧玩家。",
    bluff: "邪恶冒充共情者时需要维持连续数字。逐夜复盘存活邻居，能发现不符合座位变化的说法。",
  },
  fortune_teller: {
    mechanics: "每夜选择两名不同玩家，若其中有恶魔或那名善良红鲱鱼，就得到“是”；否则得到“否”。失能时答案可能错误。",
    play: "用多夜交叉组合排除目标，不要把单次“是”直接等同于两人中必有恶魔。",
    example: "先查二号+三号得“是”，再查二号+五号得“否”；若信息可靠，三号的嫌疑明显上升。",
    bluff: "冒充占卜师必须持续给出每夜两人和结果。要求其说明交叉验证逻辑，可检验信息是否临时编造。",
  },
  undertaker: {
    mechanics: "夜晚得知当天被处决且死亡的玩家角色，包括因处女能力被立即处决的提名者。夜杀和猎魔人射杀不属于处决。",
    play: "推动有信息价值的处决，并在次日用结果验证死者声明与其他人的叙事。",
    example: "四号自称士兵却被处决；夜里你看到男爵，次日可揭露其伪装并回查他保护过的人。",
    bluff: "邪恶可冒充送葬者为队友洗白。核对每晚报告是否只来自真正的日落处决。",
  },
  monk: {
    mechanics: "除首夜外，每夜选择另一名玩家，使其免受当夜恶魔能力影响；不能保护自己，也不阻止处决等其他来源的死亡。",
    play: "轮换保护强信息角色，避免形成可预测模式；不要公开今晚准备保护谁。",
    example: "你保护调查员后黎明无人死亡，可能是保护成功，也可能是恶魔攻击士兵或其他能力造成。",
    bluff: "恶魔常冒充僧侣解释无死亡夜。追问其历夜保护目标，并与死亡情况交叉核对。",
  },
  ravenkeeper: {
    mechanics: "只有在夜间死亡时才会触发：临死前选择一名玩家并得知其角色；白天被处决不会触发。",
    play: "不要太早公开身份。可以表现得像高价值信息角色，诱使恶魔夜里杀你。",
    example: "你假装共情者并被夜杀，随后查验五号；次日公布结果，但仍要考虑自己是否中毒。",
    bluff: "活着的人声称自己是守鸦人无法提供结果很正常；若有人白天死亡后声称触发，则与规则不符。",
  },
  virgin: {
    mechanics: "第一次被提名时能力消耗；若当时处女能力正常且提名者实际登记为镇民，提名者立即被处决并结束白天。",
    play: "邀请较可信的镇民在合适时机提名你，可用一次高强度公开验证换取当天处决机会。",
    example: "自称调查员的人提名你却没死：他可能是酒鬼、邪恶伪装者，你可能中毒，或他并未登记为镇民。",
    bluff: "邪恶冒充处女常借口“我可能中毒”。真正触发失败同样有多种解释，不能仅凭一次失败定罪。",
  },
  slayer: {
    mechanics: "整局一次，在白天公开选择一名玩家射击，也可选择自己或死者；若目标登记为恶魔且能力正常，目标死亡。任何存活玩家都可作出同样宣称来伪装。隐士也可能被登记成恶魔。",
    play: "先收集足够信息再开枪；公开能力意味着没有第二次机会。",
    example: "两条独立线索都指向六号时再射击。无人死亡不保证六号是好人，也可能是你失能。",
    bluff: "邪恶冒充猎魔人可以故意射好人并解释无死亡；追问为何在该时机消耗唯一能力。",
  },
  soldier: {
    mechanics: "能力正常时，恶魔的攻击不会杀死你。你仍会死于处决、处女等其他来源；醉酒或中毒时恶魔可以杀死你。",
    play: "适度隐藏身份，让恶魔浪费一次攻击；无死亡夜不能单独证明你是士兵。",
    example: "你声称弱信息角色并在夜里被攻击，黎明无人死亡；可以择机公开，但僧侣保护也能造成相同现象。",
    bluff: "小恶魔常冒充士兵，尤其在无死亡夜。用处决、信息链和发言一致性判断，不要只看是否夜里存活。",
  },
  mayor: {
    mechanics: "只剩三名存活玩家且当天无人被处决时，能力正常可让善良获胜；恶魔攻击你时，也可能改为另一名玩家死亡。",
    play: "前期保护身份，终盘再推动三人无处决。提前公开会让邪恶围绕你的能力制造假局面。",
    example: "三人局中你确认恶魔无法阻止能力，可请求所有人结束白天而不处决；若你失能则不会获胜。",
    bluff: "恶魔终盘冒充镇长会诱导好人放弃处决。三人局要求用此前信息确认，而不是相信最后声明。",
  },
  butler: {
    mechanics: "每夜必须选择一名其他玩家作为主人，不能跳过，也可以选择已死亡玩家；活着时，白天你可以举手，但只有主人也举手时赞成票才有效；死亡后能力失效，幽灵票不再受主人限制。系统会自动校验。",
    play: "选择你目前较信任、且可能积极投票的玩家；公开主人可让村庄理解票数变化。",
    example: "你举手赞成处决六号，但主人没有举手，系统结算时你的票不计入有效票。",
    bluff: "邪恶冒充管家可用“票未生效”解释票数。结合公开票数与其声称的主人检查前后一致。",
  },
  drunk: {
    mechanics: "你不会看到“酒鬼”；你会看到一个镇民身份，并像该镇民一样收到操作或信息，但实际能力始终无效。终局才揭晓真相。",
    play: "按你看到的镇民正常游玩，同时接受信息可能出错；多寻找独立证据验证自己的结果。",
    example: "你以为自己是调查员并得到二选一线索；提名处女却没有触发，因为你实际属于外来者。",
    bluff: "邪恶可把矛盾都归因于“你可能是酒鬼”。不要让酒鬼成为万能解释，应结合外来者数量和男爵配置判断。",
  },
  recluse: {
    mechanics: "你是善良外来者，却可能被其他能力登记为邪恶、某个爪牙或恶魔，即使死亡后也可能如此；你不会因此获得对应能力。",
    play: "尽早说明自己可能污染信息，但不要要求所有人无条件相信；主动帮助解释调查员、厨师等矛盾。",
    example: "调查员看到你与另一人中有一位男爵，并不代表你真是男爵；猎魔人射你也可能使你死亡。",
    bluff: "邪恶很爱冒充隐士来吸收所有坏信息。检查外来者数量，以及他是否只在被查坏后才临时声明。",
  },
  saint: {
    mechanics: "如果你因白天处决而死亡，邪恶立即获胜；夜间死亡或其他非处决死亡不会触发这个失败条件。",
    play: "必须避免被处决，但也要给村庄足够理由相信你；过度沉默会让邪恶更容易冒充你。",
    example: "你被提名时应解释身份与现有外来者配置，请求村庄寻找比冒险处决你更安全的目标。",
    bluff: "邪恶冒充圣徒能形成处决威慑。用图书管理员线索、男爵导致的外来者数量和长期票型判断。",
  },
  poisoner: {
    mechanics: "每夜选择一名玩家，使其能力失效并可能获得错误信息，效果持续到次日黄昏；投毒者死亡或失能时毒效立即停止。目标不会收到中毒提示。",
    play: "盯住强信息角色可持续压制，轮换目标则更难让好人从错误模式锁定你。",
    example: "投毒共情者后，他仍会看到一个正常数字；你可以在白天顺势用发言强化这条错误线索。",
    bluff: "适合冒充调查员、厨师等首夜角色，后续无需持续制造新信息；六人局没有系统安全伪装，先听再认领。",
  },
  spy: {
    mechanics: "夜里能看到所有真实身份，并可能被善良信息能力登记为善良或镇民。被登记成镇民时也可能触发处女。",
    play: "利用完整身份构造可信信息，但不要准确得不自然；优先保护恶魔并制造好人之间的身份冲突。",
    example: "看到真实厨师后，可冒充洗衣妇并声称两人中有一位厨师，借真信息建立信用。",
    bluff: "间谍最适合冒充需要准确角色知识的镇民。过分完美、总能避开冲突的线索值得警惕。",
  },
  scarlet_woman: {
    mechanics: "恶魔死亡前至少有五名玩家存活时，存活且能力正常的你会秘密接替成为新恶魔；以恶魔死亡前人数判断。",
    play: "前期替恶魔吸收怀疑，但五人门槛附近要避免与恶魔同时暴露；接替后及时调整夜杀目标。",
    example: "六人存活时猎魔人杀死小恶魔，你立刻接替，游戏继续；之后你的手机会出现恶魔行动。",
    bluff: "可冒充士兵或镇长这类无需持续报信息的镇民，减少接替前后说法断裂。",
  },
  baron: {
    mechanics: "被动改变开局配置：增加两名外来者并减少两名镇民。开局后没有需要点击的主动能力。",
    play: "利用异常外来者数量制造身份冲突；你可以故意声称一个镇民身份，让真实外来者看起来可疑。",
    example: "六人局出现三个外来者声明时，不一定三人中有多个邪恶，可能正是男爵改变了配置。",
    bluff: "适合冒充调查员并编造爪牙二选一，或冒充无需持续信息的士兵；六人局会告诉你恶魔的姓名与编号，但发言时不要暴露只有队友才知道的关系。",
  },
  imp: {
    mechanics: "除首夜外每夜选择一名玩家死亡（可以选择自己或死者）；选择自己时，若仍有存活爪牙，则由一名爪牙秘密接替成为新小恶魔。",
    play: "优先击杀能持续产出可靠信息的角色，同时用自己的善良伪装影响白天提名。必要时自杀传位可洗白队友。",
    example: "你冒充士兵并夜杀共情者；若自己即将被处决，可在前一夜选择自己，把恶魔身份传给存活爪牙。",
    bluff: "常见伪装是士兵、镇长或已完成首夜信息的镇民。六人局没有系统给出的三个安全伪装，认领前先观察角色声明。",
  },
};
